import { ReactNode } from "react";
import "./Loading.scss";

interface LoadingProps {
  title?: string;
  children?: ReactNode;
}

/**
 * Just the loading spinner. Takes little space and is inline.
 */
export function LoadingSpinner() {
  return (
    <span className="loading-spinner">
      <span />
      <span />
      <span />
    </span>
  );
}

/**
 * Linear loading indicator. Takes no space to prevent content shift while loading. Covers full width.
 */
export function LoadingLinear() {
  return (
    <span className="loading-linear">
      <span />
      <span />
    </span>
  );
}

/**
 * Loading component with a LoadingSpinner and optional title and children.
 *
 * This takes some space. Should be used in place of loading content.
 */
export function Loading({ title, children }: LoadingProps) {
  return (
    <div className="loading">
      <h2>
        <LoadingSpinner /> {!!title && title}
      </h2>
      {children}
    </div>
  );
}

interface LoadingMaskProps extends LoadingProps {
  fixed?: boolean;
}

/**
 * Covers the containing container by default. Shows Loading component centered.
 *
 * Set fixed to cover the entire viewport.
 */
export function LoadingMask({ fixed = false, ...props }: LoadingMaskProps) {
  return (
    <div className={`loading-mask ${fixed ? "fixed" : ""}`}>
      <Loading {...props} />
    </div>
  );
}

/**
 * Covers the containing container by default.
 *
 * Set fixed to cover the entire viewport.
 */
export function Mask({
  fixed = false,
  children,
}: {
  fixed?: boolean;
  children?: ReactNode;
}) {
  return (
    <div className={`loading-mask ${fixed ? "fixed" : ""}`}>{children}</div>
  );
}
